import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Button from '../../../button';
import AddSmallSVG from '../../../../assets/svg/add-icon-small.svg';
import { useAddQueryMessage, useDeleteQueryNote, useEditQueryNote, useGetQueryNotes } from '../../../../redux/human-resources/hook/queries';
import FormTextArea from '../../../form-textarea';

export const QueryNotes = () => {

    const {
        formState: { isValid },
        errors,
        } = useForm({
        mode: 'onChange',
    });

    const { id } = useParams();

    const [type, setType] = useState('add');
    const [noteId, setNoteId] = useState();

    const { data: query_notes} = useGetQueryNotes(id);
    const { user } = useSelector((state) => state.userSlice);

    const { mutateAsync: addQueryNote, isLoading: addQueryNoteloading } =
      useAddQueryMessage()

    const { mutateAsync: editQueryNote, isLoading: editQueryNoteloading } = useEditQueryNote();
    const { mutateAsync: deleteQueryNote } = useDeleteQueryNote();

    const [comment, setComment] = useState()

    const [addNote, setAddNote] = useState(false);

    useEffect(() => {
        if (query_notes) {
            setType('edit')
            setQueryNotes(query_notes)
        } else {
            setType('add') 
        }
    }, [query_notes])

    const [queryNotes, setQueryNotes] = useState([])

    const submitForm = async () => {
        let payload = {
            comment,
            query_id: id
        }
        if (type === 'add') {
            await addQueryNote(payload).then(()=>{
                setNoteId('')
                setType('add')
                setComment('')
                setAddNote(false)
            })
        } else {
            let editPayload = {
                id: noteId,
                data: payload,
            }
            await editQueryNote(editPayload).then(()=>{
                setNoteId('')
                setType('add')
                setComment('')
                setAddNote(false)
            })
        }
       
    }
    return (
        <>
        <div
            className={`min-h-[120px] flex flex-col md:w-1/2 w-full gap-2 justify-start bg-white rounded-[5px] border border-[#dbdce3]`}
        >
            <div className='flex flex-row justify-between items-center bg-blue-100 p-3'>
                <div className='font-medium text-[14px] text-color-black flex flex-col'>
                    Admin Comments
                </div>
            </div>
            {addNote?
            <form className='form p-2 py-2'>
                <div className='flex flex-col md:flex-row justify-between gap-3 text-[13px]'>
                    <div className='w-full'>
                        <FormTextArea
                            label='Note'
                            name='comment'
                            value={comment}
                            placeholder={'Enter Review Comment'}
                            onInput={(e) => {
                                setComment(e.target.value)
                            }}
                            className='text-[14px]'
                            type='text'
                            error={errors.comment}
                            errorMessage={errors.comment && errors.comment.message}
                        />
                    </div>
                </div>
                <div className='flex md:flex-row justify-end gap-4'>
                    <Button
                        text='Cancel' 
                        type='button' 
                        onClick={() => {
                            setNoteId('')
                            setType('add')
                            setComment('')
                            setAddNote(false)
                        }}
                        textClass={'!text-[11px]'}
                        className={'h-[35px] w-[100px]'}
                        theme={'third'} 
                    />
                    <Button
                        text={type==='add'?'Add': 'Update'}
                        type='button' 
                        disabled={!comment || !id}
                        onClick={() => {
                            submitForm()
                        }}
                        textClass={'!text-[11px]'}
                        className={'h-[35px] w-[100px]'}
                        loading={addQueryNoteloading || editQueryNoteloading} 
                    />
                </div>
            </form>:
            <>
                {queryNotes && queryNotes?.query_notes?.length > 0?
                <div className='flex flex-col p-2 !max-h-[250px] overflow-y-auto'>
                    <div className='flex flex-row justify-end items-center gap-1 text-right pr-2 italic text-hr-primary-1 text-[14px] mb-3'>
                        <img src={AddSmallSVG} alt={'add_note'} className={'h-[12px] w-[12px]'} />
                        <span 
                            className='italic text-hr-primary-1 text-[13px] hover:underline hover:text-[14px] duration-300 cursor-pointer font-bold' 
                            onClick={()=> {
                                setNoteId('')
                                setType('add')
                                setComment('')
                                setAddNote(true)
                            }}
                        >
                            Add Note
                        </span>
                    </div>
                    {queryNotes?.query_notes.map((item,index) => (
                        <>
                            <div className='flex md:flex-row items-end px-2 py-2 justify-between border bg-highlight rounded-md'>
                                <div className='flex flex-col  text-gray-500'>
                                    <div className='text-[11px] text-gray-500'>{item.created.split('T').join(' ').split('.')[0]}</div>
                                    <div className='header-5 text-gray-700 pb-1'>{item.user_id === user?.id ? 'You': item.user} added a comment</div>
                                    <div className='text-[12px] text-gray-600'>{item.comment}</div>
                                    
                                </div>
                                {item.user_id === user?.id?
                                <div className='flex flex-row gap-2 text-[12px] italic'>
                                    <div 
                                        className='text-hr-primary-1 hover:underline cursor-pointer duration-300 hover:scale-105 hover:font-semibold'
                                        onClick={() => {
                                            setNoteId(item.id)
                                            setType('edit')
                                            setComment(item.comment)
                                            setAddNote(true)
                                        }}
                                    >
                                        Update
                                    </div>
                                    <div 
                                        className='text-rose-600 hover:underline cursor-pointer duration-300 hover:scale-105 hover:font-semibold'
                                        onClick={() => {
                                            deleteQueryNote(item.id)
                                        }}
                                    >
                                        Delete
                                    </div>
                                </div>
                                :
                                null}
                            </div>
                            {index !== queryNotes.length - 1?
                                <hr className='divider mt-2 mb-1' />
                            :
                            null
                            }
                        </>
                    ))}
                </div>
                :
                <div className='text-center w-[100%] p-3 italic text-hr-primary-1 text-[14px]'>
                    <span 
                    className='text-center w-[100%] p-3 italic text-hr-primary-1 text-[14px] hover:underline hover:text-[16px] duration-300 cursor-pointer' 
                    onClick={()=> {
                        setNoteId('')
                        setType('add')
                        setComment('')
                        setAddNote(true)
                    }}
                    >
                        Add Note
                    </span>
                </div>
                }
            </>}
        </div>
        <div
            className={`h-[120px] flex flex-col md:w-1/2 w-full gap-2 justify-start bg-white rounded-[5px] border border-[#dbdce3]`}
        >
            <div className='flex flex-row justify-between items-center bg-blue-100 p-3'>
                <div className='font-medium text-[14px] text-color-black flex flex-col'>
                    Employee Comments
                </div>
            </div>
                {queryNotes && queryNotes?.employee_notes?.length > 0?
                <div className='flex flex-col pt-3 !max-h-[250px] overflow-y-auto'>
                    {queryNotes.employee_notes.map((item,index) => (
                        <div>
                            <div className='flex md:flex-row  items-end pl-8 pr-8 pb-3 justify-between'>
                                <div className='flex flex-col  text-gray-500'>
                                    <div className='text-[11px] text-gray-500'>{item.created.split('T').join(' ').split('.')[0]}</div>
                                    <div className='header-5 text-gray-700 pb-1'>{item.user_id === user?.id ? 'You': item.user} added a comment</div>
                                    <div className='text-[12px] text-gray-600'>{item.comment}</div>
                                    
                                </div>
                                {item.user_id === user?.id?
                                <div className='flex flex-row gap-2 text-[13px] italic'>
                                    <div 
                                        className='text-hr-primary-1 hover:underline cursor-pointer duration-300'
                                        onClick={() => {
                                            setNoteId(item.id)
                                            setType('edit')
                                            setComment(item.comment)
                                            setAddNote(true)
                                        }}
                                    >
                                        Update
                                    </div>
                                    <div 
                                        className='text-rose-600 hover:underline cursor-pointer duration-300'
                                        onClick={() => {
                                            deleteQueryNote(item.id)
                                        }}
                                    >
                                        Delete
                                    </div>
                                </div>
                                :
                                null}
                            </div>
                            {index !== queryNotes.length - 1?
                            <hr className='divider -mt-3 mb-1' />
                            :
                            null
                            }
                        </div>
                    ))}
                </div>
                :
                <div className='text-center w-[100%] p-3 italic text-hr-primary-1 text-[14px]'>
                    <span className='text-center w-[100%] p-3 italic text-hr-primary-1 text-[14px] hover:underline hover:text-[16px] duration-300 cursor-pointer'>
                        No Employee Comments Added
                    </span>
                </div>
                }
            
        </div>
        </>
    );
};